var $ = require('jquery');

$(function(){

  function photoFade() {
    $('.js-HeroFade li:first').removeClass('is-Hide');
    $('.js-HeroFade li:first').clone(true).appendTo('.js-HeroFade ul');
    $('.js-HeroFade li:last').removeClass('is-Show');

    setTimeout(function(){
      $('.js-HeroFade li:last').addClass('is-Show');
      $('.js-HeroFade li:nth-child(5n)').addClass('is-Hide');
      $('.js-HeroFade li:first').remove();
    },1000);
  }

  photoFade();
  setInterval(function(){
    photoFade();
  }, 4000);

});
